import PropTypes from 'prop-types';
import { isNil } from 'lodash/fp';
import { Button, ButtonSize, ButtonVariant } from 'app/components/core/Button';
import { useFormContext } from './Form.jsx';

export function Next({
    children,
    size = ButtonSize.MEDIUM,
    variant = ButtonVariant.PRIMARY,
    onClick
}) {
    const context = useFormContext();

    if (isNil(context)) {
        throw new Error('<Next> must be used within a <Form> component');
    }

    const { isVisibleValid } = context;

    return (
        <Button size={size} variant={variant} disabled={!isVisibleValid} onClick={onClick}>
            {children}
        </Button>
    );
}

Next.propTypes = {
    /** The label content of the next button. */
    children: PropTypes.node,
    size: PropTypes.oneOf(Object.values(ButtonSize)),
    variant: PropTypes.oneOf(Object.values(ButtonVariant)),
    onClick: PropTypes.func.isRequired
};
